import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import InvestigationalDisclaimer from "./components/InvestigationalDisclaimer";
import Home from "./pages/Home";
import Investors from "./pages/Investors";
import Grants from "./pages/Grants";
import Partners from "./pages/Partners";
import Warcliv from "./pages/Warcliv";
import Contact from "./pages/Contact";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/investors" element={<Investors />} />
              <Route path="/grants" element={<Grants />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/warcliv" element={<Warcliv />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <InvestigationalDisclaimer />
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
